<template>
    <div class="locale-font">
        <div class="breadcrumb-container">
            <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
        </div>
        <div class="header-container">
            <h1 class="head-line-page">
                {{ breadcrumbsItem[1].text }}
            </h1>
            <div class="button-container">
                <v-btn
                    class="mr-4"
                    color="primary"
                    outlined
                    @click="backToEmployees()">
                    {{ $vuetify.lang.t('$vuetify.blacklistForm.cancel') }}
                </v-btn>

                <v-btn
                    color="primary"
                    @click="submit()">
                    {{ $vuetify.lang.t('$vuetify.blacklistForm.save') }}
                </v-btn>
            </div>
        </div>
        <div class="container-info">
            <v-card class="profile-card">
                <v-form
                    lazy-validation
                    ref="form"
                    v-model="valid">
                    <p class="content-header">
                        {{ this.$vuetify.lang.t('$vuetify.employee.profile') }}
                    </p>
                    <div class="d-flex">
                        <div class="upload-container">
                            <upload-image
                                ref="uploadImage"
                                :img="imgProfile(employeeData.image)"
                                @change-profile-img="changeProfileImg"
                                @remove-img="removeProfileImg"
                                :isEditing="true"
                                :showDescriptionForUploadToDmp="true"
                                :canDelete="true">
                            </upload-image>
                        </div>
                        <div class="profile-container">
                            <div class="row">
                                <!-- EMPLOYEE ID -->
                                <div class="col-6">
                                    <v-text-field
                                        v-model="employeeData.employee_id"
                                        :label="this.$vuetify.lang.t('$vuetify.employee.employeeId')"
                                        :placeholder="this.$vuetify.lang.t('$vuetify.employee.employeeId')"
                                        height="45"
                                        :rules="inputRules">
                                    </v-text-field>
                                </div>

                                <!-- EMAIL -->
                                <div class="col-6">
                                    <v-text-field
                                        v-model="employeeData.email"
                                        :label="this.$vuetify.lang.t('$vuetify.employee.emailAddress')"
                                        height="45"
                                        :placeholder="this.$vuetify.lang.t('$vuetify.employee.emailAddress')"
                                        :rules="emailRules">
                                    </v-text-field>
                                </div>
                            </div>

                            <!-- NAME TH -->
                            <div class="row">
                                <div class="col-6">
                                    <div class="row">
                                        <!-- PREFIX TH -->
                                        <div class="col-4">
                                            <div :class="labelSelector">
                                                {{ this.$vuetify.lang.t('$vuetify.employee.prefixThai') }}
                                            </div>
                                            <v-select
                                                class="no-padding-selector"
                                                v-model="employeeData.prefix_th"
                                                :items="prefixOptions.th"
                                                height="35"
                                                :placeholder="this.$vuetify.lang.t('$vuetify.employee.prefixThai')"
                                                background-color="#ffffff"
                                                dense filled
                                            ></v-select>
                                        </div>

                                        <!-- FIRST NAME TH -->
                                        <div class="col-8">
                                            <v-text-field
                                                v-model="employeeData.first_name_th"
                                                :label="this.$vuetify.lang.t('$vuetify.employee.firstNameThai')"
                                                height="45"
                                                :placeholder="this.$vuetify.lang.t('$vuetify.employee.firstNameThai')"
                                                :rules="inputRules">
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>

                                <!-- LAST NAME TH -->
                                <div class="col-6">
                                    <v-text-field
                                        v-model="employeeData.last_name_th"
                                        :label="this.$vuetify.lang.t('$vuetify.employee.lastNameThai')"
                                        height="45"
                                        :placeholder="this.$vuetify.lang.t('$vuetify.employee.lastNameThai')"
                                        :rules="inputRules">
                                    </v-text-field>
                                </div>
                            </div>

                            <!-- NAME EN -->
                            <div class="row">
                                <div class="col-6">
                                    <div class="row">
                                        <!-- PREFIX EN -->
                                        <div class="col-4">
                                            <div :class="labelSelector">
                                                {{ this.$vuetify.lang.t('$vuetify.employee.prefixEnglish') }}
                                            </div>
                                            <v-select
                                                class="no-padding-selector"
                                                v-model="employeeData.prefix_en"
                                                :items="prefixOptions.en"
                                                height="35"
                                                :placeholder="this.$vuetify.lang.t('$vuetify.employee.prefixEnglish')"
                                                background-color="#ffffff"
                                                dense filled
                                            ></v-select>
                                        </div>

                                        <!-- FIRST NAME EN -->
                                        <div class="col-8">
                                            <v-text-field
                                                v-model="employeeData.first_name_en"
                                                :label="this.$vuetify.lang.t('$vuetify.employee.firstNameEnglish')"
                                                height="45"
                                                :placeholder="this.$vuetify.lang.t('$vuetify.employee.firstNameEnglish')"
                                                :rules="inputRules">
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>

                                <!-- LAST NAME EN -->
                                <div class="col-6">
                                    <v-text-field
                                        v-model="employeeData.last_name_en"
                                        :label="this.$vuetify.lang.t('$vuetify.employee.lastNameEnglish')"
                                        height="45"
                                        :placeholder="this.$vuetify.lang.t('$vuetify.employee.lastNameEnglish')"
                                        :rules="inputRules">
                                    </v-text-field>
                                </div>
                            </div>

                            <!-- POSITION -->
                            <div class="row">
                                <div class="col-12">
                                    <div :class="labelSelector">
                                        {{ this.$vuetify.lang.t('$vuetify.employee.position') }}
                                    </div>
                                    <v-autocomplete
                                        class="no-padding-selector"
                                        v-model="employeeData.position"
                                        :items="positionList"
                                        height="40"
                                        placeholder="- Select Permission -"
                                        background-color="#ffffff"
                                        dense filled
                                    ></v-autocomplete>
                                </div>
                            </div>

                            <!-- ORGANIZATION -->
                            <div class="row">
                                <div class="col-12">
                                    <v-text-field
                                        :label="this.$vuetify.lang.t('$vuetify.employee.bureau')"
                                        height="45"
                                        v-model="employeeData.organization_name"
                                        :placeholder="this.$vuetify.lang.t('$vuetify.employee.bureau')"
                                        filled
                                        readonly>
                                    </v-text-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div :class="labelSelector">
                                        {{ this.$vuetify.lang.t('$vuetify.employee.setUpLineMenu') }}
                                    </div>
                                    <v-select
                                        class="no-padding-selector"
                                        v-model="employeeData.line_role"
                                        :items="lineRoleList"
                                        height="40"
                                        :placeholder="this.$vuetify.lang.t('$vuetify.employee.selectLineMenu')"
                                        background-color="#ffffff"
                                        dense filled
                                    ></v-select>
                                </div>
                                <div
                                    v-if="employeeData.line_role === 'HBU'"
                                    class="col-6">
                                    <div :class="labelSelector">
                                        {{ this.$vuetify.lang.t('$vuetify.employee.lineAndReportPermission') }}
                                    </div>
                                    <line-permission-select
                                        class="no-padding-selector"
                                        :tags="linePermission"
                                        v-model="employeeData.line_permission">
                                    </line-permission-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-form>
            </v-card>
            <v-card class="status-card">
                <p class="content-header">
                    {{ this.$vuetify.lang.t('$vuetify.employee.status') }}
                </p>
                <div class="row">
                    <div class="col-6">
                        <div>
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.employee.startDate') }}
                            </div>
                            <div class="data-profile mb-3">
                                {{employeeData.status_start}}
                            </div>
                        </div>
                        <div>
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.employee.resignDate') }}
                            </div>
                            <div class="data-profile">
                                {{employeeData.status_end}}
                            </div>
                        </div>
                    </div>
                    <div class="col-6 image-status">
                        <img :src="statusImage" />
                    </div>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import LinePermissionSelect from '@/components/Employee/LinePermissionSelect'
import profileDefault from '@/assets/user_default.png'
import ActiveEmployee from '@/assets/employee/active.png'
import DeactiveEmployee from '@/assets/employee/deactive.png'
export default {
    name: 'EmployeeInfo',

    components: {
        UploadImage,
        LinePermissionSelect
    },

    data () {
        return {
            employeeId: null,
            employeeData: {
                image: null,
                prefix_th: null,
                prefix_en: null,
                first_name_th: null,
                first_name_en: null,
                last_name_th: null,
                last_name_en: null,
                email: null,
                status: null,
                status_start: null,
                status_end: null,
                position: null,
                line_role: null,
                line_permission: null,
                employee_id: null,
                organization_name: null
            },
            prefixOptions: { en: [], th: [] },
            positionList: [],
            lineRoleList: [],
            linePermission: [],
            statusImage: '',
            isNewImage: false,
            isRemoveImage: false,
            valid: true,
            inputRules: [
                v => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.employee.empRequiredField')),
                v => this.$validator.lengthNotExceed(v, 255, this.$vuetify.lang.t('$vuetify.employee.empExceededField'))
            ],
            emailRules: [
                // email => this.$validator.hasValue(email, this.$vuetify.lang.t('$vuetify.employee.empRequiredField')),
                email => this.$validator.lengthNotExceed(email, 255, this.$vuetify.lang.t('$vuetify.employee.emailIsExceeded255Characters')),
                email => this.$validator.correctFormat(email, /.+@.+\..+/, this.$vuetify.lang.t('$vuetify.employee.invalidEMailFormat'))
            ]
        }
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.employee.employeeManagement'),
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'Employees'
                    }
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.employee.editEmployeeProfile'),
                    disabled: true
                }
            ]
        },
        imageSizeError () {
            return {
                title: this.errorMsg,
                text: this.$vuetify.lang.t('$vuetify.employee.msgErrorImageSize'),
                type: 'notify-error'
            }
        },
        labelSelector () {
            return `label-selector lang-${this.$vuetify.lang.current}`
        }
    },

    methods: {
        imgProfile (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        },

        async getEmployeeData () {
            const res = await this.axios.get(`employee/${this.employeeId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.employeeData = res.data.data
                this.displayStatusImage()
            }
        },

        async getPositionOptions () {
            const res = await this.axios.get('position/options')
            if (res && res.data && res.data.status === 'ok') {
                this.positionList = res.data.data
            }
        },

        async getLineRole () {
            const res = await this.axios.get('employee/line-role')
            if (res && res.data && res.data.status === 'ok') {
                this.lineRoleList = res.data.data
            }
        },

        async getLinePermission () {
            const res = await this.axios.get('bureau/line-permission/options')
            if (res && res.data && res.data.status === 'ok') {
                this.linePermission = res.data.data
            }
        },

        async getPrefix () {
            const langs = ['th', 'en']
            const url = 'employee/prefix/options'
            for (let i = 0; i < langs.length; i++) {
                const lang = langs[i]
                const res = await this.axios.get(url + `?lang=${lang}`)
                if (res && res.data && res.data.status === 'ok') {
                    this.prefixOptions[lang] = res.data.data
                }
            }
        },

        displayStatusImage () {
            if (this.employeeData.status === 'ACT') {
                this.statusImage = ActiveEmployee
            } else {
                this.statusImage = DeactiveEmployee
            }
        },

        backToEmployees () {
            this.$router.push({ name: 'Employees' }, () => {})
        },

        changeProfileImg (event) {
            const fileList = event.target.files
            const maxFileSize = 200000
            const minFileSize = 25000

            const reader = new FileReader()
            let imgBase64 = null
            if (fileList[0] && (fileList[0].size < minFileSize || fileList[0].size > maxFileSize)) {
                this.$notify(this.imageSizeError)
            } else {
                if (fileList[0]) {
                    reader.onload = () => {
                        imgBase64 = reader.result
                        this.employeeData.image = imgBase64
                        this.isNewImage = true
                        this.isRemoveImage = false
                    }

                    reader.readAsDataURL(fileList[0])
                }
            }
        },

        removeProfileImg () {
            this.isRemoveImage = true
            this.employeeData.image = null
        },

        notifySuccess () {
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.employee.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.employee.updated'),
                type: 'notify-success'
            })
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }

            let imageUpload = null
            if (this.isNewImage) {
                imageUpload = this.employeeData.image
            }

            const body = { ...this.employeeData, image: imageUpload }

            if (this.isRemoveImage) {
                delete body.image
            }

            if (!body.email) {
                body.email = null
            }

            delete body.status
            delete body.status_start
            delete body.status_end
            delete body.organization_name
            if (body.line_role !== 'HBU') {
                body.line_permission = []
            }

            this.$store.dispatch('setLoading', true)
            const res = await this.axios.put(`employee/edit/${this.employeeId}`, body)
            this.$store.dispatch('setLoading', false)
            if (res && res.data && res.data.status === 'ok') {
                this.notifySuccess()
                this.$router.push({ name: 'Employees' }, () => {})
            } else {
                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.employee.somethingWrong'),
                    text: this.$vuetify.lang.t('$vuetify.employee.tryAgain'),
                    type: 'notify-error'
                })
            }
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        this.employeeId = this.$route.params.id
        const toLoaded = [
            this.getPositionOptions(),
            this.getLineRole(),
            this.getLinePermission(),
            this.getPrefix()
        ]
        await Promise.all(toLoaded)
        await this.getEmployeeData()
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getLineRole()
                await this.getEmployeeData()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .container-info {
        display: grid;
        min-height: 100%;
        height: 100%;
        margin-bottom: 0rem;
        grid-gap: 25px;
        grid-template-columns: calc(66% - 12.5px) calc(34% - 12.5px);
    }

    .profile-card {
        padding: 36px 38px;
        border-radius: 15px;
    }

    .status-card {
        padding: 36px 38px;
        border-radius: 15px;
    }

    .label-profile {
        color: #6c6c6c;
        font-size: 14px;
        font-weight: normal;
    }

    .label-selector {
        color: rgba(0, 0, 0, 0.6);
        font-size: 13px;
        font-weight: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &.lang-th {
            margin-top: 8px;
            margin-bottom: -7px;
            font-family: Prompt;
        }
        &.lang-en {
            margin-top: 9px;
            margin-bottom: -8px;
            font-family: LexendDeca;
        }
    }

    .data-profile {
        font-size: 16px;
        font-weight: normal;
        color: #131410;
        font-family: 'Roboto';
    }

    .upload-container {
        min-width: 160px;
        width: 22%;
    }

    .profile-container {
        width: 78%;
    }

    .image-status {
        display: flex;
        justify-content: flex-end;
    }

    .header-container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 1rem;

        .button-container {
            display: flex;
            align-items: center;
        }
    }

    ::v-deep .no-padding-selector .v-input__slot {
        padding: 0px !important;
        background: none !important;
    }

    ::v-deep .breadcrumb-container .v-breadcrumbs {
        padding-bottom: 18px;
    }
</style>
